<!--
 * @Descripttion: 
 * @version: 1.0
 * @Author: Erik Zhang
 * @Date: 2021-02-14 23:36:16
 * @LastEditors: Erik Zhang
 * @LastEditTime: 2021-06-10 21:27:22
-->
<template>
  <edu-layout type="table">
    <veStuGraduationAuditInfo viewType="CW" slot="table"></veStuGraduationAuditInfo>
  </edu-layout>
</template>

<script>
import veStuGraduationAuditInfo from './base/veStuGraduationAuditInfo';
export default {
  components: {
    veStuGraduationAuditInfo
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {}
};
</script>
<style lang="less" scoped></style>
